
/**
 * Expression is formed like:
 * IsGeneric == @0
 * where '@0' is the index of the Params array
 */
export class DynamicQuery {
    constructor(public Expression: string, public Params: Array<any>) { }
}